import { useAppSelector } from 'hooks/redux';
import React, { useEffect, useRef } from 'react';
import WS from 'utils/ws';
import {
    setQuotes,
    setAvailableTickers,
    setSelectedTickers
} from 'store/reducers/quotes';
import { useDispatch } from 'react-redux';
import { _updateWorkspaces } from 'store/reducers/TabsSlice';
import { useLocation } from 'react-router-dom';
import { useTimer } from 'use-timer';
import Error from 'utils/Notifications/Error';

const WSHandler = () => {

    const onTimeOver = () => {
        Error('Данные с сервера не поступают');
    };
    const { start, reset } = useTimer({
        onTimeOver,
        endTime: 5
    });
    const dispatch = useDispatch();
    
    const page_name = useAppSelector(
        (state) => state.quotesPage.activePage && state.quotesPage.activePage.name
    );

    const active_page_id = useAppSelector(
        (state) => state.quotes.active_page_id
    );

    const quotes_info = useAppSelector(
        state => state.quotes.info
    );

    const qi = useRef(quotes_info);
    qi.current = quotes_info;

    const _id = useRef(active_page_id);
    _id.current = active_page_id;

    const { pathname } = useLocation();

    function updateFn(event: any) {
        if (!event || (event && !event.data)) {
            return;
        }
        reset();
        const data = JSON.parse(event.data);
        const quotes_data = [];
        const selected_tickers = [];
        let available_tickers;
        const decline_checks = [
            {
                reason: 'updating with non active workspaces',
                fn: (data: any[]) => {
                    const part = data[0];
                    const obs = qi.current[_id.current];
                    if (obs) {
                        const check = obs.find(x => x === part?.id);
                        if (!check) {
                            return true;
                        }
                    }
                }
            }
        ];

        for (const check of decline_checks) {
            const test = check.fn(data);
            if (test) {
                // console.log('quotes.updater: ', check.reason);
                return;
            }
        }

        for (const dat of data) {
            if (typeof dat === 'undefined') {
                continue;
            }
            const item = {
                id: dat.id,
                columns: dat.columns,
                params: dat.params,
            };
            const selected_tickers_item = {
                id: dat.id,
                data: dat.selected_tickers
            };
            selected_tickers.push(selected_tickers_item);
            //@ts-ignore
            quotes_data.push(item);
            if (!available_tickers && Array.isArray(dat.available_tickers)) {
                available_tickers = dat.available_tickers
                    .slice()
                    .map((item) => item.Name);
            }
        }

        dispatch(setQuotes({ data: quotes_data, reference: _id.current }));
        dispatch(_updateWorkspaces({ data: quotes_data, reference: _id.current }));
        dispatch(setAvailableTickers(available_tickers));
        if (Array.isArray(selected_tickers) && selected_tickers.length) {
            dispatch(setSelectedTickers(selected_tickers));
        }
    }

    useEffect(() => {
        if (!active_page_id) {
            WS.drop();
            return;
        }

        if (!pathname.includes('quotes')) {
            WS.drop();
            return;
        }

        start();

        WS.connect({
            tab_id: active_page_id,
            onUpdate: updateFn,
            name: page_name
        });

        WS.openCheckErrorsConnection()
    }, [active_page_id, pathname]);
    return <></>;
};

export default WSHandler;
